export default "__VITE_ASSET__DRtV2cn1__"